import {observable, action} from 'mobx';
import arrayMove from 'array-move';

import Group from 'domain/model/Group';
import PluginSettings from 'domain/model/PluginSettings';
import MarkupStyleSettings from './MarkupStyleSettings';
import MarkupTemplateThemeSettings from './MarkupTemplateThemeSettings';
import BaseStyleSettings from './BaseStyleSettings';

export default class SettingsPageSettings {
	/** @type {Map<String, PluginSettings>} */
	@observable storefront_plugin_settings;
	/** @type {Map<String, boolean>} */
	@observable storefronts_with_personal_settings;
	/** @type {Map<String, boolean>} */
	@observable storefronts_to_clear;

	/** @type {Array<Group>} */
	@observable groups;

	/** @type {Array<int>} */
	@observable group_ids_to_delete;

	/** @type {Map<String, MarkupTemplateThemeSettings>} */
	@observable markup_template_theme_settings;
	/** @type {Map<String, boolean>} */
	@observable theme_ids_with_personal_settings;
	/** @type {Map<String, boolean>} */
	@observable loaded_theme_ids;


	/** @type {Map<String, BaseStyleSettings>} */
	@observable base_style_theme_settings;


	/** @type {Map<String, Map<String, MarkupStyleSettings>>} */
	@observable markup_style_theme_storefront_settings;
	/** @type {Map<String, Map<String, boolean>>} */
	@observable theme_storefronts_with_personal_style_settings;
	/** @type {Map<String, Map<String, boolean>>} */
	@observable theme_storefront_personal_style_settings_to_clear;

	constructor(
		storefront_plugin_settings, storefronts_with_personal_settings,
		groups,
		markup_template_theme_settings, theme_ids_with_personal_settings,
		base_style_theme_settings,
		markup_style_theme_storefront_settings, theme_storefronts_with_personal_style_settings
	) {
		this.storefront_plugin_settings = new Map(storefront_plugin_settings.map(settings => ([
			settings.storefront,
			new PluginSettings(settings.settings)
		])));
		this.storefronts_with_personal_settings = new Map(storefronts_with_personal_settings.map(storefront => ([storefront, true])));
		this.storefronts_to_clear = new Map();


		this.groups = groups.map(group => new Group(group));
		this.group_ids_to_delete = [];


		this.markup_template_theme_settings = new Map(markup_template_theme_settings.map(settings_element => ([
			settings_element.theme_id,
			new MarkupTemplateThemeSettings(settings_element.settings),
		])));
		this.theme_ids_with_personal_settings = new Map(theme_ids_with_personal_settings.map(theme_id => ([
			theme_id,
			true,
		])));
		this.loaded_theme_ids = new Map(markup_template_theme_settings.map(settings_element => ([
			settings_element.theme_id,
			true,
		])));


		this.base_style_theme_settings = new Map(base_style_theme_settings.map(settings_element => ([
			settings_element.theme_id,
			new BaseStyleSettings(settings_element.settings),
		])));


		this.markup_style_theme_storefront_settings = new Map();
		markup_style_theme_storefront_settings.forEach(settings_element => {
			const style_settings = new MarkupStyleSettings(settings_element.settings);

			if (!this.markup_style_theme_storefront_settings.has(settings_element.theme_id)) {
				this.markup_style_theme_storefront_settings.set(settings_element.theme_id, new Map())
			}

			this.markup_style_theme_storefront_settings
				.get(settings_element.theme_id)
				.set(settings_element.storefront, style_settings);
		});
		this.theme_storefronts_with_personal_style_settings = new Map(theme_storefronts_with_personal_style_settings.map(
			theme_storefronts => ([
				theme_storefronts.theme_id,
				new Map(theme_storefronts.storefronts.map(storefront => ([storefront, true])))
			])
		));
		this.theme_storefront_personal_style_settings_to_clear = new Map();
	}

	@action updateGroups(groups) {
		this.groups = groups.map(group => new Group(group));
		this.group_ids_to_delete = [];
	}

	@action addNewGroup() {
		this.groups.push(new Group());
	}

	/** @type {Group} */
	@action removeGroup(group) {
		this.groups = this.groups.filter(g => g._key !== group._key);

		this.group_ids_to_delete.push(group.id);
	}

	@action changeGroupsOrder(old_index, new_index) {
		this.groups = arrayMove(this.groups, old_index, new_index);
	}
}